<template>
    <template v-if="filteredBadge">
        <Icon
            v-if="showSmall"
            :name="`badge-${filteredBadge}`"
            :class="[$style.badge_icon, { [$style.isHide]: isHide }]"
            :lazy="true"
        />
        <template v-else>
            <Icon
                :name="`badge-${filteredBadge}-text`"
                :class="[$style.badge_icon, $style.desktop_override, { [$style.isHide]: isHide }]"
                :lazy="true"
            />
            <Icon
                :name="`badge-${filteredBadge}`"
                :class="[$style.badge_icon, $style.mobile_override, { [$style.isHide]: isHide }]"
                :lazy="true"
            />
        </template>
    </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import Icon from '@/components_new/Icon/Icon.vue'
import { BadgeType } from '@/types'

interface BadgesProps {
    badges: BadgeType[] | undefined
    isSmall?: boolean
    isHide?: boolean
}

const props = defineProps<BadgesProps>()
const badgesPriority: BadgeType[] = ['hot', 'top', 'new']
const filteredBadge = computed(() => {
    if (props.badges) {
        for (let i = 0; i < badgesPriority.length; i++) {
            if (props.badges.includes(badgesPriority[i])) {
                return badgesPriority[i]
            }
        }
    }
    return null
})
const alwaysSmallBadges: Partial<Record<BadgeType, boolean>> = { new: true }
const showSmall = computed(() => props.isSmall || (filteredBadge.value && alwaysSmallBadges[filteredBadge.value]))
</script>

<style module>
.badge_icon {
    position: absolute;
    top: -6px;
    left: -8px;

    height: 34px;
    width: auto;

    filter: opacity(100%);
    transition: all 0.4s ease-in-out;
    pointer-events: none;
}

.isHide {
    filter: opacity(0%);
}

.desktop_override {
    display: none;
}

@media (--tablet-plus) {
    .desktop_override {
        display: block;
    }

    .mobile_override {
        display: none;
    }
}
</style>
